module.exports = __webpack_public_path__ + "static/img/_3.5b304a80.png";